import { Step1, type Step1Data } from './step1'
import { Step2, type Step2Data } from './step2'
import { Step3, type Step3Data } from './step3'
import { Step4, type Step4Data } from './step4'
import { Step5, type Step5Data } from './step5'
export type AllStepsData = Step1Data &
  Step2Data &
  Step3Data &
  Step4Data &
  Step5Data

export const steps = [
  <Step1 key="investorTest1" />,
  <Step2 key="investorTest2" />,
  <Step3 key="investorTest3" />,
  <Step4 key="investorTest4" />,
  <Step5 key="investorTest5" />,
]
